const productRecommendationsSection = document.querySelector(
  ".product-recommendations"
);
const url = productRecommendationsSection.dataset.url;

window.addEventListener("load", () => {
  setRecommendedProductsHTML()
    .then(() => {
      const upsellCheckboxes = document.querySelectorAll(
        ".complementary-products__block input"
      );
      initializeAtcPrice(upsellCheckboxes);
      setCheckboxChange(upsellCheckboxes);
      initalizeAtcClick();
    })
    .catch((err) => {
      console.log(err);
    });
});

const initializeAtcPrice = (upsellCheckboxes) => {
  if (upsellCheckboxes) {
    let checkedInputs = document.querySelectorAll(
      ".complementary-products__block input:checked"
    );
    const InitPrice = getTotalPrice(checkedInputs);
    displayPrice(InitPrice, checkedInputs.length);
  }
};

const setCheckboxChange = (upsellCheckboxes) => {
  upsellCheckboxes.forEach((input) => {
    input.addEventListener("change", () => {
      let checkedInputs = document.querySelectorAll(
        ".complementary-products__block input:checked"
      );
      let totalPrice = getTotalPrice(checkedInputs);
      displayPrice(totalPrice, checkedInputs.length);
    });
  });
};

const getTotalPrice = (checkedInputs) => {
  let totalPrice = 0;
  checkedInputs.forEach((input) => {
    totalPrice += Number(input.getAttribute("aria-price"));
  });
  return totalPrice.toFixed(2);
};

let upsellAtcButton;
const displayPrice = (price, quantity) => {
  upsellAtcButton = document.querySelector(".recommended-product__atc");
  switch (quantity) {
    case 0:
      upsellAtcButton.disabled = true;
      upsellAtcButton.innerHTML = "Select a product...";
      break;
    case 1:
      upsellAtcButton.disabled = false;
      upsellAtcButton.innerHTML = `Add to Cart - $${price}`;
      break;
    case 2:
      upsellAtcButton.innerHTML = `Add 2 to Cart - $${price}`;
      break;
    default:
      upsellAtcButton.innerHTML = `Add all 3 to Cart - $${price}`;
  }
};

const setRecommendedProductsHTML = async () => {
  await fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;

      const recommendations = html.querySelector(".product-recommendations");
      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
    })
    .catch((e) => {
      console.error(e);
    });
};

const initalizeAtcClick = () => {
  upsellAtcButton.addEventListener("click", (e) => {
    e.target.innerHTML = "adding...";
    let checkedInputs = document.querySelectorAll(
      ".complementary-products__block input:checked"
    );
    let formData = {
      items: [],
      sections: "cart-drawer,cart-icon-bubble",
    };
    checkedInputs.forEach((input) => {
      formData.items.push({
        quantity: 1,
        id: input.value,
        form_type: "product",
        properties: { _upsell_tagging: "FBT-true" },
      });
    });

    $.ajax({
      type: "POST",
      url: "/cart/add",
      dataType: "json",
      data: formData,
      success: async function (res) {
        e.target.innerHTML = "Added";
        let cartDrawerEl = document.querySelector("#CartDrawer");
        let html = new DOMParser()
          .parseFromString(res.sections["cart-drawer"], "text/html")
          .querySelector("#CartDrawer").innerHTML;
        cartDrawerEl.innerHTML = html;
        let bubbleEl = document.querySelector("#cart-icon-bubble");
        bubbleEl.innerHTML = res.sections["cart-icon-bubble"];
        document.querySelector("#cartDrawerContainer").classList.add("active");
      },
    }).fail(function (e) {
      return window.location.reload(), !1;
    });
  });
};
